import { type DateLike, useDateFormat } from '@vueuse/core';

export const useFormatDate = (start: MaybeRefOrGetter<DateLike>, end: MaybeRefOrGetter<DateLike>) => {
    const { locale: activeLocale } = useI18n();

    const startDate = useDateFormat(start, 'D MMMM YYYY', { locales: activeLocale.value });
    const endDate = useDateFormat(end, 'D MMMM YYYY', { locales: activeLocale.value });

    const fullDate = computed(() => {
        if (startDate.value === endDate.value || (startDate.value && !endDate.value)) {
            return startDate.value;
        } else if (!startDate.value && endDate.value) {
            return endDate.value;
        } else if (startDate.value && endDate.value) {
            return `${startDate.value} - ${endDate.value}`;
        } else {
            return '';
        }
    });

    return {
        startDate,
        endDate,
        fullDate
    };
};
